export default __webpack_public_path__ + "static/appointment-section-2466f7a21890367d27cfb4684dd04caa.jpg";